module.exports = __webpack_public_path__ + "img/emaapou6.5f43afda.svg";